import {Component, AfterViewInit, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import * as Chart from 'chart.js';
@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit, AfterViewInit {
  issues: any;
  compliance = 0;
  functional= 0;
  performance = 0;
  security = 0;
  usability = 0;
  none = 0;

  canvas: any;
  ctx: any;
  constructor (private http: HttpClient) { }
  ngOnInit() {
    this.http.get('issue/api/byclass/Compliance').subscribe(data => {
      this.issues = data;
      this.compliance += this.issues.length;
    });
    this.http.get('issue/api/byclass/Performance').subscribe(data => {
      this.issues = data;
      this.performance += this.issues.length;
    });
    this.http.get('issue/api/byclass/Security').subscribe(data => {
      this.issues = data;
      this.security += this.issues.length;
    });
    this.http.get('issue/api/byclass/Functional').subscribe(data => {
      this.issues = data;
      this.functional += this.issues.length;
    });

    this.http.get('issue/api/byclass/Usability').subscribe(data => {
      this.issues = data;
      this.usability += this.issues.length;
    });



  }



  ngAfterViewInit() {

    setTimeout(() => {

      if (this.compliance + this.functional + this.performance + this.security + this.usability === 0) {
        this.none = 1;
      } else {
        this.none = 0;
      }

      Chart.defaults.global.defaultFontColor = '#000';
      this.canvas = document.getElementById('myChart');
      this.ctx = this.canvas.getContext('2d');
      const myChart = new Chart(this.ctx, {
        type: 'pie',
        data: {
          labels: ['Compliance',
            'Functional',
            'Performance',
            'Security',
            'Usability'],
          datasets: [{
            label: '# of Votes',
            data: [this.compliance, this.functional, this.performance, this.security, this.usability,this.none],
            backgroundColor: [
              'rgba(255, 99, 132, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(12, 96, 120, 1)',
              'rgba(56, 240,156, 1)',
              'rgba(0, 0,0, 0.5)'
            ],
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          display: true,
          maintainAspectRatio: false
        }
      }); } , 500);

  }
}



// WEBPACK FOOTER //
// ./src/app/table/table.component.ts